module.exports = __webpack_public_path__ + "img/circle27.c6d4dd4d.png";